// A generic component that lets you conditionally wrap (child) components
export const ConditionalWrapper = ({ condition, wrapper, children, }) => (condition ? wrapper(children) : children);
